// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var URLUtils$SmartcutsMacros = require("../../../bs-utils/src/URLUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var ContentOptionality$SmartcutsMacros = require("../semantics/ContentOptionality.bs.js");
var ContentOptionalityConfig$SmartcutsMacros = require("../semantics/ContentOptionalityConfig.bs.js");

var concatAndResolveUrl = (function (url, concat) {
  var url1 = url.split('/');
  var url2 = concat.split('/');
  var url3 = [ ];
  for (var i = 0, l = url1.length; i < l; i ++) {
    if (url1[i] == '..') {
      url3.pop();
    } else if (url1[i] == '.') {
      continue;
    } else {
      url3.push(url1[i]);
    }
  }
  for (var i = 0, l = url2.length; i < l; i ++) {
    if (url2[i] == '..') {
      url3.pop();
    } else if (url2[i] == '.') {
      continue;
    } else {
      url3.push(url2[i]);
    }
  }
  return url3.join('/');
});

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "src",
                Decco.stringToJson(v.src)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var src = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "src"), null));
    if (src.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                selector: selector._0,
                src: src._0
              }
            };
    }
    var e = src._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".src" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(param) {
  return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", src: " + (param.src + "}")));
}

function selectorGet(param) {
  return [param.selector];
}

function updateSelector(f, v) {
  return {
          selector: Curry._1(f, v.selector),
          src: v.src
        };
}

function getInputIdentifier(param) {
  return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}

var RecordingAndAuthoring = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  selectorGet: selectorGet,
  updateSelector: updateSelector,
  getInputIdentifier: getInputIdentifier
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "src",
                Decco.stringToJson(v.src)
              ],
              [
                "optionality",
                ContentOptionality$SmartcutsMacros.t_encode(v.optionality)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var src = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "src"), null));
    if (src.TAG === /* Ok */0) {
      var optionality = ContentOptionality$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "optionality"), null));
      if (optionality.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  selector: selector._0,
                  src: src._0,
                  optionality: optionality._0
                }
              };
      }
      var e = optionality._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".optionality" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = src._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".src" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$1(param) {
  return "{optionality: " + (ContentOptionality$SmartcutsMacros.stringify(param.optionality) + (", selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", src: " + (param.src + "}")))));
}

function selectorGet$1(param) {
  return [param.selector];
}

var Playback = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  selectorGet: selectorGet$1
};

var CommandValue = {
  RecordingAndAuthoring: RecordingAndAuthoring,
  Playback: Playback
};

function isImgSrcEqualToImageUrl(imgSrc, imageUrl, tabUrl) {
  var _imgSrcUrl = URLUtils$SmartcutsMacros.$$URL.fromString(imgSrc);
  if (_imgSrcUrl !== undefined) {
    return imgSrc === imageUrl.toString();
  }
  var arg = URLUtils$SmartcutsMacros.$$URL.fromString(tabUrl);
  var tabOrigin = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected tab url to be valid").origin;
  var fullImgSrcUrl = imgSrc.startsWith("/") ? tabOrigin + imgSrc : concatAndResolveUrl(tabOrigin, imgSrc);
  return fullImgSrcUrl === imageUrl.toString();
}

function willGenerateAPlaybackParam(param) {
  return false;
}

function fromAuthoringCommandValue(_authoringCommandValue) {
  return ContentOptionalityConfig$SmartcutsMacros.$$default;
}

function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, maybeConfig) {
  return {
          selector: commandValue.selector,
          src: commandValue.src,
          optionality: OptionUtils$SmartcutsMacros.withDefault(ContentOptionalityConfig$SmartcutsMacros.$$default, maybeConfig)
        };
}

var AuthoringConfig = {
  willGenerateAPlaybackParam: willGenerateAPlaybackParam,
  fromAuthoringCommandValue: fromAuthoringCommandValue,
  applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue
};

exports.concatAndResolveUrl = concatAndResolveUrl;
exports.CommandValue = CommandValue;
exports.isImgSrcEqualToImageUrl = isImgSrcEqualToImageUrl;
exports.AuthoringConfig = AuthoringConfig;
/* Selector-SmartcutsMacros Not a pure module */
